export const Lista_Grupo_Sanguineo = [
    "A",
    "B",
    "AB",
    "0",
] as const;